module.exports = "../../../../platform/assets/pageMainIcon/icon-shuzhi-1-purple.svg";